import { Col, Grid, Row } from 'react-bootstrap'

import FirstSectionPanel from '../SummaryDataCollectionGroup/FirstSectionPanel.js'
import FiveSectionPanel from './FiveSectionPanel.js'
import FourSectionPanel from './FourSectionPanel.js'
import React from 'react'
import SecondSectionPanel from '../SummaryDataCollectionGroup/SecondSectionPanel.js'
import SixSectionPanel from './SixSectionPanel.js'
import ThirdSectionPanel from './ThirdSectionPanel.js'

export default class BeamlineDataCollectionGroupPanel extends React.Component {
  render() {
    return (
      <Grid fluid style={{ marginTop: '15px' }}>
        <Row>
          <Col xs={12} sm={6} md={2}>
            <FirstSectionPanel datacollectiongroup={this.props.datacollectiongroup} />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <SecondSectionPanel datacollectiongroup={this.props.datacollectiongroup} />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <ThirdSectionPanel datacollectiongroup={this.props.datacollectiongroup} />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <FourSectionPanel {...this.props} />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <FiveSectionPanel {...this.props} />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <SixSectionPanel {...this.props} />
          </Col>
        </Row>
      </Grid>
    )
  }
}
